import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { catchError, map, of } from 'rxjs'
import { AppStore } from '../app.store'
import { MeService } from '../services/me/me.service'

const FALLBACK_PAGE = '/customers'

// Sends the user to the default page set on their staff profile when they land on the root url (e.g. after login)
export const defaultPageGuard: CanActivateFn = () => {
    const router = inject(Router)
    const me = inject(AppStore).me()

    if (me) {
        return router.parseUrl(me.defaultPage || FALLBACK_PAGE)
    }

    return inject(MeService)
        .getMe()
        .pipe(
            map((me) => router.parseUrl(me.defaultPage || FALLBACK_PAGE)),
            catchError(() => of(router.parseUrl(FALLBACK_PAGE)))
        )
}
